import { FC } from 'react';
import { StyledAvatar, StyledImage } from './Avatar.styles';

export interface AvatarProps {
  image: string;
  text: string;
}

/**
Image with accompanying text. Useful for displaying a small representation of a user or person
*/
export const Avatar: FC<AvatarProps> = ({ image, text }) => {
  return (
    <StyledAvatar>
      <StyledImage src={image} alt={text} />
      {text}
    </StyledAvatar>
  );
};

export default Avatar;
